export default [
  {
    path: '/project/:alias/:projectAlias/commit',
    component: () => import('./pages/commits.layout.vue'),
    children: [
      {
        path: '',
        name: 'commits-list',
        component: () => import('./pages/page-commits.vue')
      },
      {
        path: 'commit-compare',
        name: 'commit-compare',
        component: () => import('./pages/commit-compare/commit-compare.vue')
      }
    ]
  },
  {
    path: '/project/:alias/:projectAlias/commit/:commitId',
    component: () => import('./pages/commit.layout.vue'),
    children: [
      {
        path: '',
        name: 'commit',
        component: () => import('./pages/page-commit.vue')
      }
    ]
  }
];
